import { getToken, onMessage } from "firebase/messaging";
import { toast } from "sonner";
import { getMessagingIfSupported, VAPID_KEY } from "./firebase";
import api from "./api";

let foregroundBound = false;

export function pushSupported() {
  return typeof window !== "undefined" && "Notification" in window && "serviceWorker" in navigator;
}

export async function enableWebPush() {
  if (!pushSupported()) throw new Error("This browser doesn't support push notifications");

  const messaging = await getMessagingIfSupported();
  if (!messaging) throw new Error("Push isn't supported in this browser");

  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission was blocked");

  const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: registration });
  if (!token) throw new Error("Could not get a device token");

  await api.registerPush(token, "web");

  if (!foregroundBound) {
    foregroundBound = true;
    onMessage(messaging, (payload) => {
      const n = payload.notification || {};
      toast(n.title || "WYVN", { description: n.body });
    });
  }
  return token;
}
